<!--创建学期model-->
<template>
    <div>
        <vue-scroll :ops="$ops">
            <el-form ref="semester" :model="semester" label-width="55px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="学期">
                            <el-select v-model="semester_id" placeholder="请选择学期" style="width: 200px">
                                <el-option
                                        v-for="item in  $parentInfo.semesters"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-form>
                <el-form-item>
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>年级</th>
                            <th>时长</th>
                            <th>价格</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(grade,index) in grades_classHour" :key="index">
                            <td>
                                <el-select v-model="grade.grade_id" placeholder="请选择年级" style="width: 200px" disabled>
                                    <el-option
                                            v-for="item in  $parentInfo.grades"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-select v-model="grade.time" placeholder="请选择时长" style="width: 200px">
                                    <el-option
                                            v-for="item in  $parentInfo.times"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-input-number size="medium" :controls=false v-model="grade.price" placeholder="请输入价格"></el-input-number>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </el-form-item>
            </el-form>
        </vue-scroll>
        <div class="text-right">
            <el-button type="primary" @click="handleStoreSemester()"
                       :loading="$parentInfo.dialog_CreateClassHour.button_loading">保存
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateSemester",
        data() {
            return {
                activeName: '1',
                semester: {
                    id: '',
                    name: '',
                },
                semester_id:'',
                grades_classHour: [
                    {
                        grade_id:1,
                        grade_name:'预初',
                        time:'1',
                        price:''
                    },
                    {
                        grade_id:2,
                        grade_name:'初一',
                        time:'1',
                        price:''
                    },
                    {
                        grade_id:3,
                        grade_name:'初二',
                        time:'1',
                        price:''
                    },
                    {
                        grade_id:4,
                        grade_name:'初三',
                        time:'1',
                        price:''
                    },
                    {
                        grade_id:5,
                        grade_name:'高一',
                        time:'1',
                        price:''
                    },
                    {
                        grade_id:6,
                        grade_name:'高二',
                        time:'1',
                        price:''
                    },
                    {
                        grade_id:7,
                        grade_name:'高三',
                        time:'1',
                        price:''
                    },
                ]
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleClassHourFormat();
        },
        methods: {
            handleClassHourFormat(){
                this.$parentInfo.dialog_CreateClassHour.loading = true;
                this.$wApi.send(this.$parentInfo.path, 'classHour_format', {});
            },
            //添加学期
            handleStoreSemester() {
                this.$parentInfo.dialog_CreateClassHour.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'store_classHour', {
                    'semester_id':this.semester_id,
                    'grades_classHour': this.grades_classHour,
                });
            },
        }
    }
</script>

<style scoped>
    .text {
        position: absolute;
        left: 25px;
        top: 25px;
    }

    .box_relative {
        position: relative;
    }

    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }
</style>
